<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/contact" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Business talks",
    "pageDesc":"Business talks is Baianat event in which we gather entrepreneurs and business enthusiasts from all over the world for conversations.",
    "mantra":"Business talks |and more.",
    "mantraDesc":"Business talks is Baianat event in which we gather entrepreneurs and business enthusiasts from all over the world for thorough conversations and experience sharing. Through sessions, keynotes, panel discussions and workshops we aim to turn business dilemmas into math equations that can be solved easily.",
    "sec1":"Strategy driven conversations.",
    "sec1Items":{
      "1":{
        "title":"Business innovation ",
        "desc":"Exploring the essentials for innovation in business and the mechanisms needed for adopting this mentality across the different industries."
      },
      "2":{
        "title":"Customer experience",
        "desc":"Discussing the mentality of the 21st  century users and how to tailor products around their needs."
      },
      "3":{
        "title":"Economics ",
        "desc":"Analyzing the different economic situations and discussing the different insights to predict future implications."
      },
      "4":{
        "title":"Advertising",
        "desc":"Spotting on the latest attention engineering techniques and studying buyers from the psychological side."
      }
    },
    "sec2":"Experience entrepreneurship in close.",
    "sec2Items":{
      "1":{
        "title":"Free spaces",
        "desc":"Have the opportunity to chat closely with speakers and get their insights on your critical matters."
      },
      "2":{
        "title":"Parallel sessions",
        "desc":"Shuffle between sessions and attend for the speakers you love and the topics that will enrich your experience."
      },
      "3":{
        "title":"Like minded network",
        "desc":"Feel home with participants  who share your values and ambitions in the business area."
      },
      "4":{
        "title":"Party atmosphere ",
        "desc":"Work hard and party harder! Following this motto, we choose the venue and the location for every talk to be welcoming and full of spirit."
      }
    },

    "cta":"Join our <br> business talks!"
  },
  "ar": {
    "pageTitle":"مناقشات الأعمال التجارية",
    "pageDesc":"مناقشات الأعمال التجارية هو أحد فعاليات بيانات يجتمع فيه رجال الأعمال ومحبي الأعمال التجارية من جميع أنحاء العالم لتبادل المحادثات . ",
    "mantra":"مناقشات الأعمال |التجارية والمزيد.",
    "mantraDesc":" مناقشات الأعمال التجارية أحد الفعاليات التي تنظمها بيانات حيث يجتمع فيه رجال الأعمال ومحبي الأعمال التجارية من جميع أنحاء العالم من أجل إجراء محادثات ملهمة وتبادل الخبرات. من خلال الجلسات والمحاورات وحلقات النقاش المتنوعة وورش العمل، التي نهدف من خلالها إلى تحويل معضلات الأعمال التجارية إلى معادلات رياضية يمكن حلها بسهولة. ",
    "sec1":"محادثات تقودها الاستراتيجية.",
    "sec1Items":{
      "1":{
        "title":"الابتكار في الأعمال التجارية ",
        "desc":"تعرف على أساسيات الابتكار في الأعمال التجارية والآلية اللازمة التي تحتاج إليها من أجل بناء هذه العقلية في الصناعات المختلفة."
      },
      "2":{
        "title":"تجربة المستهلك",
        "desc":"مناقشة العقلية التي يتمتع بها مستهلكو القرن 21 وتعرف كيف تكيف المنتجات والخدمات وفقًا لاحتياجاتهم."
      },
      "3":{
        "title":"الاقتصاديات ",
        "desc":"تحليل المواقف الاقتصادية المختلفة ومناقشة الأفكار المتعددة للتنبؤ بالآثار المستقبلية."
      },
      "4":{
        "title":"الإعلان",
        "desc":"نسلط الضوء على أحدث التقنيات التكنولوجية ودراسة سلوك المشترين من الجانب النفسي. "
      }
    },
    "sec2":"تجربة ريادة الأعمال عن قرب.",
    "sec2Items":{
      "1":{
        "title":"مساحة حرة ",
        "desc":"لديك فرصة من أجل الدردشة عن قرب مع أهم المتحدثين والحصول على آرائهم والرؤى الخاصة بهم في كل القضايا التي تخصك."
      },
      "2":{
        "title":"جلسات موازية",
        "desc":"المزج بين الدورات و حضور المتحدثين الذين تحبهم والموضوعات التي سوف تثري تجربتك."
      },
      "3":{
        "title":"شبكة تواصل",
        "desc":"اشعر بالانتماء مع المشاركين في الفعالية الذين يشاركونك نفس قيمك و طموحاتك في مجال الأعمال التجارية."
      },
      "4":{
        "title":"العمل والمرح ",
        "desc":"العمل بجد والقليل من الاسترخاء! باتباع هذا الشعار، نختار المكان والموقع لكل فعالية ليكون مليئًا بالروح."
      }
    },

    "cta":"انضم الي <br> مناقشات الأعمال التجارية!"
  }
}
</i18n>
